const features = [
  {
    icon: 'ri-speed-up-line',
    title: '不缓冲极速播放',
    desc: '智能CDN加速引擎，全国多节点覆盖。1080P高清片源也能秒加载，彻底告别转圈等待，追番体验丝般顺滑。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费零门槛',
    desc: '无需注册登录，无需付费订阅，无需安装插件。打开即看，纯粹观影。我们承诺永久免费，让动漫回归分享的初心。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量动漫资源库',
    desc: '10000+部动漫番剧持续扩充中，日漫、国漫、经典番剧全面覆盖。每周50+部新番同步更新，永不剧荒。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">平台优势</h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10">为什么600万动漫迷选择6080影视</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((f, i) => (
            <div key={i} className="group rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6 text-center transition-all duration-300 hover:border-primary-200 cursor-pointer">
              <div className={`w-14 h-14 mx-auto mb-4 rounded-2xl flex items-center justify-center transition-transform duration-300 group-hover:scale-110 ${
                i === 0 ? 'bg-primary-100' : i === 1 ? 'bg-accent-100' : 'bg-secondary-100'
              }`}>
                <i className={`${f.icon} text-2xl ${
                  i === 0 ? 'text-primary-500' : i === 1 ? 'text-accent-500' : 'text-secondary-500'
                }`} style={{ width: '1em', height: '1em' }}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}